import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import { partial } from '../../util/translation/translation';
import NewsAPIForm from './components/NewsAPIForm';

const s = partial('shared');

const NewsAPIFormPage = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      entityName: values.entityName,
    };
    try {
      await Api.news.createApiAccess(payload);
      setLoading(false);
      history.replace('/news?tab=2');
    } catch (err) {
      toast.error(err || s('somethingWentWrong'));
      setLoading(false);
    }
  };
  return (
    <Container>
      <Loading loading={loading} />
      <Row>
        <Col md={12}>
          <h3 className="page-title">{s('create')}</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <NewsAPIForm onSubmit={onSubmit} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NewsAPIFormPage;
